import { render, staticRenderFns } from "./MenuItemChild.vue?vue&type=template&id=d659d45a"
import script from "./MenuItemChild.vue?vue&type=script&lang=js"
export * from "./MenuItemChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports